import React from "react";

import styled from "styled-components";
import { arrayOrEmpty } from "utils";

import { StickRow } from "components/pad-generator/hooks";

import { useStickDataManagementController } from "./hooks";
import { ScenarioField } from "./types/field";
import { TemplatePreview } from "./views";
import { FieldSelection } from "./views/FieldSelection";
import { TemplatePanel } from "./views/TemplatePanel";

const PageContainer = styled.div`
  background-color: #f5f5f5;
  display: flex;
`;

const RightColumn = styled.div`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 24px;

  .ant-card + .ant-card {
    margin-top: 24px;
  }
`;

const LeftColumn = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  padding: 24px 0 24px 24px;
`;

interface StickDataManagementProps {
  scenarioId?: string;
  schema?: string;
  wells: Array<{ uwid: string }>;
  fields?: ScenarioField[];
  onFieldsChange?: (field: ScenarioField[]) => void;
  stickData: StickRow[];
}

const StickDataManagement: React.FC<StickDataManagementProps> = (props) => {
  const controller = useStickDataManagementController(props);
  return (
    <PageContainer>
      <LeftColumn>
        <TemplatePanel
          templates={controller.templates}
          isLoading={controller.isTemplatesLoading}
          hasChanges={controller.hasTemplateChanges}
          selectedTemplateId={controller.selectedTemplateId}
          hasFields={controller.selectedFields.length > 0}
          isReplacingFields={controller.isReplacingFields}
          onSelectTemplate={controller.handleSelectTemplate}
          onSaveTemplate={controller.handleSaveTemplate}
          onClearAllFields={controller.handleClearAllFields}
          onUpdateTemplate={controller.handleUpdateTemplate}
          onRenameTemplate={controller.handleRenameTemplate}
          onDeleteTemplate={controller.handleDeleteTemplate}
        />
      </LeftColumn>
      <RightColumn>
        <FieldSelection
          customFields={controller.customFields}
          selectedFields={controller.selectedFields}
          onAddField={controller.handleAddField}
          onRemoveField={controller.handleRemoveField}
          onCustomFieldAssign={controller.handleCustomFieldAssign}
        />

        <TemplatePreview
          selectedFields={controller.selectedFields}
          wells={props.wells}
          uploadedData={controller.uploadedData}
          isDragging={controller.isDragging}
          isDownloading={controller.isDownloading}
          isUploading={controller.isUploading}
          uploadError={controller.uploadError ?? controller.validationError}
          onDownloadTemplate={controller.onDownloadTemplate}
          onFileUpload={controller.handleFileUploadWithApi}
          onDragOver={controller.handleDragOver}
          onDragLeave={controller.handleDragLeave}
          onDrop={controller.handleDrop}
          stickData={arrayOrEmpty(props.stickData).map((data, i) => ({
            ...data,
            id: data.id ?? props.wells[i]?.uwid
          }))}
        />
      </RightColumn>
    </PageContainer>
  );
};

export default StickDataManagement;
